//import { any } from "prop-types";
import {
  GET_LINE_INFO_FAILED,
  GET_LINE_INFO_REQUEST,
  GET_LINE_INFO_SUCCESS,
  SET_LINE_ITEM_IPS_FAILED,
  SET_LINE_ITEM_IPS_REQUEST,
  SET_LINE_ITEM_IPS_SUCCESS,
  RESTART_LINE_ITEM_IPS_FAILED,
  RESTART_LINE_ITEM_IPS_REQUEST,
  RESTART_LINE_ITEM_IPS_SUCCESS,
  RESET_LINE_ITEM_DATA
} from "../Actions/CLineItemActions";

const initialState = {
  loading: false,
  line_item_id: "",
  line_item_without_user_id:"",
  line_item_name: "",
  dur:"",
  imps:"",
  unit:"",
  rows: [{ipAddress:[],comment:[]}],
  //ipAddresses: [],
  success: false,
  timer: 1,
  startTime:"",
  timePassed:"",
  endTime:"",
  adsType:'',
  getLineInfoLoader:false,
  bids:""
};

export const ClineItemsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_LINE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        adsType: action?.payload?.type,
        getLineInfoLoader:true,
      };
    case GET_LINE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        getLineInfoLoader:false,
        line_item_id: action.payload.line_item_id,
        line_item_without_user_id:action.payload?.line_item_without_user_id,
        line_item_name: action.payload.line_item_name,
        dur:action.payload.dur,
        imps:action.payload.imps,
        unit:action.payload.unit,
        rows: action.payload.rows,
        //ipAddresses: action.payload.ip,
        timer:action.payload.timer,
        startTime:action.payload.startTime,
        timePassed:action.payload?.timePassed,
        endTime:action.payload?.endTime,
        bids:action.payload.bids,
      };
    case GET_LINE_INFO_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        getLineInfoLoader:false,
      };
    case SET_LINE_ITEM_IPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SET_LINE_ITEM_IPS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        line_item_name: action.payload.line_item_name,
        dur:action.payload.dur,
        imps:action.payload.imps,
        unit:action.payload.unit,
        rows: action.payload.rows,
        // ipAddresses: action.payload.ip,
        timer:action.payload.timer,
        startTime:action.payload?.startTime,
        endTime:action.payload?.endTime,
        bids:action.payload.bids,
      };
    case SET_LINE_ITEM_IPS_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case RESTART_LINE_ITEM_IPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RESTART_LINE_ITEM_IPS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        line_item_name: action.payload.line_item_name,
        dur:action.payload.dur,
        imps:action.payload.imps,
        unit:action.payload.unit,
        rows: action.payload.rows,
        // ipAddresses: action.payload.ip,
        timer:action.payload.timer,
        startTime:action.payload?.startTime,
        endTime:action.payload?.endTime,
        bids:action.payload.bids,
      };
    case RESTART_LINE_ITEM_IPS_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case RESET_LINE_ITEM_DATA:
      return {
          ...state,
          loading: false,
          line_item_id: "",
          line_item_without_user_id:"",
          line_item_name: "",
          dur:"",
          imps:"",
          unit:"",
          rows: [{ipAddress:[],comment:[]}],
          // ipAddresses: [],
          success: false,
          timer: 1,
          startTime:"",
          timePassed:"",
          endTime:"",
          bids:"",
      }
    default:
      return state;
  }
};
